const pathnames = {
  HOME: "/",
  AUTH: "/auth",
  SIGN_IN: "/signin",
  SIGN_OUT: "/signout",
  DASHBOARD: "/dashboard",
  NOTIFICATIONS: "/notifications",
  UPDATE_PASSWORD: "/update-password",
  USERS: "/users",
  SETTINGS: "/settings",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_CHANGE_PASSWORD: "/settings/change-password",
  SETTINGS_CURRENCY_RATES: "/settings/currency-rates",
  SETTINGS_TAX_RATES: "/settings/tax-rates",
  ACCOUNT: "/account",
  PROFILE: "/account/profile",
  FORGOT_PASSWORD: "/account/recovery/forgot-password",
  FORGOT_PASSWORD_SUCCESS: "/account/recovery/forgot-password-success",
  RESET_PASSWORD: "/account/recovery/reset-password",
  ORGANIZATIONS: "/organizations",
  ORGANIZATIONS_ADMINS: "/organizations/administrators",
  ORGANIZATIONS_INVOICES: "/organizations/invoices",
  ORGANIZATIONS_FIRS_BUSINESSES: "/organizations/firs-businesses",
  ADMINISTRATORS: "/administrators",
  PAYMENTS: "/payments",
  BILLING: "/billing",
  BILLING_ADD_NEW: "/billing/add-new",
  PAYOUTS: "/payouts",
  PAYOUTS__PROCESS: "/payouts/process",
  PAYOUTS__CONFIRM: "/payouts/confirm",
  PAYOUTS__FUNDING_HISTORY: "/payouts/funding-history",
  PUSH_NOTIFICATIONS: "/push-notifications",
  REFERRERS: "/referrers",
  REFERRALS: "/referrers",
  REFERRALS_ORGANIZATIONS: "/referrers/earnings",
  REFERRALS_ORGANIZATIONS_PREVIEW: "/referrers/earnings/preview",
  ADMIN_LOGS: "/administrators/logs",
  ORGANIZATION_LOGS: "/organizations/logs",
  INTEGRATIONS: "/interfaces/integrations",
  INTERFACES: "/interfaces",
  TRANSMISSIONS: "/transmissions",
  API_TRANSMISSIONS: "/transmissions-api",
  TRANSMITTED_INVOICES: "/transmissions/transmitted-invoices",
  UNASSIGNED_INVOICES: "/transmissions/unassigned-invoices",
  API_LOGS: "/api-logs",
  PROMO_CODES: "/promo-codes",
  PROMO_CODES_OVERVIEW: "/promo-codes/overview",
  PROMO_CODES_CREATE: "/promo-codes/create",
  PROMO_CODES_REDEMPTIONS: "/promo-codes/redemptions",
  MARKETPLACE: "/marketplace",
  MARKETPLACE_ADDONS: "/marketplace/addons",
  MARKETPLACE_ADDON_CREATE: "/marketplace/addons/new",
  MARKETPLACE_ADDON_EDIT: "/marketplace/addons/:id/edit",
  MARKETPLACE_ADDON_DETAILS: "/marketplace/addons/:id",
  MARKETPLACE_PAYMENTS: "/marketplace/payments",
};

/**
 * Detail page for a single API request log.
 * @param {string} organizationId
 * @param {string} logId
 */
export function apiTransmissionLogPath(organizationId, logId) {
  return `${pathnames.API_TRANSMISSIONS}/${organizationId}/logs/${logId}`;
}

/**
 * Catalogue item detail page.
 * @param {string} itemId
 */
export function marketplaceItemPath(itemId) {
  return `${pathnames.MARKETPLACE_ADDONS}/${itemId}`;
}

/**
 * Catalogue item edit page.
 * @param {string} itemId
 */
export function marketplaceItemEditPath(itemId) {
  return `${pathnames.MARKETPLACE_ADDONS}/${itemId}/edit`;
}

export default pathnames;
